import isObject from 'lodash-es/isObject';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { TableHead } from './table-head';
import { TableBody } from './table-body';
import { knownClasses } from './table-util';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';
const factory = create({ theme }).properties();
const calc_col_widths = ({ colspecs, cols, rowsep, themeCss }) => {
    const specMap = new Map();
    specMap.set('tgroup', {
        columnNumber: cols,
        width: 0,
        name: 'tgroup',
        separator: rowsep === 1 ? themeCss.rowSeparator : themeCss.noRowSeparator
    });
    colspecs.forEach((item, idx) => {
        const { colwidth = '0.5in', colname = idx + 1, colsep = 1, colnum = idx + 1 } = item.colspec.attributes;
        const inches = colwidth.replace(/[^0-9.]+/g, '');
        const name = `col-${colname}`;
        const calcedSpec = {
            columnNumber: colnum,
            width: Number(inches) * 6.0,
            name,
            separator: colsep === 1 ? themeCss.columnSeparator : themeCss.noColumnSeparator
        };
        specMap.set(name, calcedSpec);
    });
    return specMap;
};
export const TableTgroup = factory(({ properties, middleware: { theme } }) => {
    const { tgroup, tableattrs } = properties();
    const themeCss = theme.classes(css);
    const { children = [], attributes = {} } = tgroup;
    const colspecs = children.filter((kid) => {
        return !!kid.colspec;
    });
    const numberOfColumns = attributes.cols || colspecs.length;
    const widths = calc_col_widths({
        colspecs,
        cols: numberOfColumns,
        rowsep: attributes.rowsep || 1,
        themeCss
    });
    const theadobj = children.find((kid) => {
        return isObject(kid) && 'thead' in kid;
    });
    const thead = theadobj ? theadobj.thead : null;
    const tbody = children.find((kid) => {
        return isObject(kid) && 'tbody' in kid;
    }).tbody;
    const { outputclass: tblclass, colsep = 1, rowsep = 1 } = tableattrs;
    const classes = [];
    if (tblclass) {
        const fixedclass = tblclass.replace('.', '_').replace('-', '_');
        if (knownClasses.has(fixedclass)) {
            classes.push(themeCss[fixedclass]);
        }
    }
    classes.push(rowsep === 1 ? themeCss.rowSeparator : themeCss.noRowSeparator);
    classes.push(colsep === 1 ? themeCss.columnSeparator : themeCss.noColumnSeparator);
    return v('table', { classes }, [thead && w(TableHead, { thead, widths }), w(TableBody, { tbody, widths })]);
});
